import React, { useEffect } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt";         
import "datatables.net-dt/css/dataTables.dataTables.min.css"; 

export default function TransactionHistory() {
    // alert('khiuhu')
    const HOSTNAME = import.meta.env.VITE_API_URL;
    const X_API_KEY = import.meta.env.VITE_X_API_KEY;
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem("user")) || null;
    async function loadTransactionHistory() {
        let inputObj = user?.user_id || null;

        if ($.fn.DataTable.isDataTable('#transactions-table')) {
            $('#transactions-table').DataTable().clear().destroy();
        }

        $('#transactions-table').DataTable({

            "stateSave": false,
            "bDestroy": true,
            "bPaginate": true,
            "ordering": false,
            "serverSide": true,
            "bAutoWidth": false,
            "deferRender": true,
            "scrollCollapse": true,
            "searching": false,
            "lengthMenu": [10, 20, 30, 50],
            "lengthChange": false,
            "orderable": false,
            // "order": [[0, 'desc']],
            "language": {
                "emptyTable": "No data available",
            },
            "ajax": {
                url: `${HOSTNAME}/api/transaction_history`,
                headers: { "x-api-key": X_API_KEY, 'Authorization': "Bearer " + token },
                data: { inputObj },
                type: 'POST',
                dataType: 'json',
                error: function (xhr, error, thrown) {

                    let message = "Something went wrong.";

                    switch (xhr.status) {
                        case 429:
                            message = "Too many requests. Please wait.";
                            break;
                        case 500:
                            message = "Server error. Try again later.";
                            break;
                        case 403:
                            message = "Access denied.";
                            break;
                        case 0:
                            message = "Network error. Check internet.";
                            break;
                    }

                    const table = $('#leaderboard-data').DataTable();

                    // Update empty message dynamically
                    table.settings()[0].oLanguage.sEmptyTable = message;

                    // Clear table to trigger empty message
                    table.clear().draw();
                }
            },

            "columns": [
                // { "data": "rank", orderable: false },
                { "data": "crd_on", orderable: false, "targets": 0 },
                { "data": "reason", orderable: false },
                { "data": "value", orderable: false }
            ],
            "columnDefs": [
                { "targets": "_all", "className": "tx-cell-border" }
            ],
            "initComplete": function (settings, json) {
                const table = $('#transactions-table').DataTable();
                setTimeout(() => table.columns.adjust().draw(false), 0);
            }
        });
    }
    useEffect(()=>{
        loadTransactionHistory();
        return () => {
            if ($.fn.DataTable.isDataTable('#transactions-table')) {
                $('#transactions-table').DataTable().clear().destroy();
            }
        };
    },[])

    return (
        <>
            <style>{`
                #transactions-data {
                    overflow-x: auto;
                    scrollbar-gutter: stable;
                }
                #transactions-data .dataTables_wrapper {
                    width: 100%;
                    overflow-x: auto;
                    scrollbar-gutter: stable;
                }
                #transactions-table {
                    width: 100% !important;
                    border-collapse: collapse !important;
                    table-layout: auto;
                }
                #transactions-table th,
                #transactions-table td {
                    border: 1px solid #2d3034 !important;
                    padding: 10px 12px !important;
                    vertical-align: middle;
                }
                #transactions-table td {
                    word-break: break-word;
                    overflow-wrap: anywhere;
                }
                table.dataTable thead th {
                    white-space: normal !important;
                    overflow-wrap: anywhere;
                    word-break: break-word;
                }

            `}</style>
            <div className="row" >
                {/* <div className='col-2'></div> */}
                <div className='col-12 col-lg-8 offset-lg-2 table-responsive' id='transactions-data'>
                    <table id="transactions-table" className="profile-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Reason</th>
                                <th>Transaction</th>
                                {/* <th>Reward</th> */}
                            </tr>
                        </thead >
                    </table>
                </div>
            </div>
        </>
    )
}
